module.exports = __webpack_public_path__ + "static/media/icon_pencil.c1024b14.svg";